export const sectors = [
    "Academia",
    "Agriculture",
    "Arts and Culture",
    "Automotive",
    "Construction",
    "Consulting",
    "Consumer Goods",
    "Defense",
    "Education",
    "Energy",
    "Environmental Services",
    "Finance",
    "Government",
    "Healthcare",
    "Hospitality",
    "Information Technology",
    "Insurance",
    "Legal Services",
    "Logistics and Supply Chain",
    "Manufacturing",
    "Media and Entertainment",
    "Mining",
    "Non-Government (NGO)",
    "Non-Profit",
    "Pharmaceuticals",
    "Private Sector",
    "Real Estate",
    "Retail",
    "Technology",
    "Telecommunications",
    "Transportation",
    "Utilities",
    "Other"
];
